import React, { useState, useEffect } from 'react';
import { getCompanyInfo } from '../api';

const buildWhatsAppLink = (value) => {
  if (!value || typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http')) return trimmed;
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length < 9) return null;
  const number = digits.startsWith('593') ? digits : (digits.startsWith('0') ? '593' + digits.slice(1) : '593' + digits);
  return `https://wa.me/${number}`;
};

const WhatsAppFloatingButton = () => {
  const [whatsappLink, setWhatsappLink] = useState(null);

  useEffect(() => {
    getCompanyInfo()
      .then(({ data }) => {
        const url = data?.whatsapp_url?.trim();
        if (url) {
          const link = url.startsWith('http') ? url : `https://wa.me/${url.replace(/\D/g, '')}`;
          setWhatsappLink(link);
          return;
        }
        const phone = data?.contact?.phone?.trim();
        const linkFromPhone = buildWhatsAppLink(phone);
        if (linkFromPhone) setWhatsappLink(linkFromPhone);
      })
      .catch(() => {});
  }, []);

  if (!whatsappLink) return null;

  const handleClick = () => {
    window.open(whatsappLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="whatsapp-floating-btn"
      aria-label="Contactar por WhatsApp"
      title="Contactar por WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor">
        <path d="M16 0C7.164 0 0 7.164 0 16c0 2.828.723 5.484 2.004 7.875L.667 30.667l7.043-1.848A15.91 15.91 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.652 0-5.18-.703-7.348-2.035l-.527-.312-2.742.719.73-2.668-.43-.512A13.26 13.26 0 012.667 16c0-7.364 5.969-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.348-10.348c-.398-.2-2.355-1.16-2.72-1.293-.365-.132-.63-.2-.895.2-.265.398-1.03 1.293-1.262 1.559-.232.265-.465.298-.863.099-.398-.2-1.68-.62-3.2-1.973-1.183-1.055-1.98-2.355-2.213-2.754-.232-.398-.025-.613.175-.81.18-.18.398-.465.597-.697.199-.232.265-.398.398-.664.132-.265.066-.497-.033-.697-.099-.199-.895-2.156-1.227-2.953-.323-.775-.652-.67-.895-.682-.232-.01-.497-.015-.762-.015s-.697.099-1.062.497c-.365.398-1.394 1.362-1.394 3.322s1.427 3.854 1.625 4.119c.199.265 2.805 4.281 6.793 5.992.948.406 1.69.649 2.268.831.953.302 1.82.26 2.506.158.765-.113 2.355-.961 2.688-1.891.332-.93.332-1.727.232-1.891-.099-.166-.365-.265-.762-.465z" />
      </svg>
    </button>
  );
};

export default WhatsAppFloatingButton;
